<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem to="/system/adminlist"> <Icon type="icon iconfont icon-qiye" /> 企业管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="md-add-circle" /> 新增企业 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <div class="titlable">
          <span>新增企业基本信息</span>
        </div>

        <!-- <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <FormItem prop="user_name">
            <Input v-model="formValidate.user_name" class="inptext" size="large" placeholder="请输入登录用户名" />
          </FormItem>
          <FormItem prop="street_name">
            <Input v-model="formValidate.street_name" class="inptext" size="large" placeholder="请输入街道名称" />
          </FormItem>
          <FormItem prop="areaid">
            <Cascader v-model="formValidate.areaid" :data="areadata" placeholder="请选择省市区" class="inptext" change-on-select />
          </FormItem>
          <FormItem>
            <Button @click="backmast">返回</Button>
            <Button type="primary" style="margin-left: 32px" @click="handleSubmit('formValidate')">提交</Button>
          </FormItem>
        </Form> -->

        <div class="cominfo">
          <div>
            请选择街道：
            <i-select v-model="jiedao" style="width: 200px; margin-left: 0.9375rem" @on-change="idgaibian">
              <i-option v-for="item in jiedaoList" :key="item.value" :value="item.street_id">{{
                item.street_name
              }}</i-option>
            </i-select>
          </div>
          <div style="margin-top: 10px">
            请选择公司类型：
            <i-select v-model="type" style="width: 200px; margin-left: 0.9375rem" @on-change="typeidgaibian">
              <i-option v-for="item1 in comtype" :key="item1.value" :value="item1.comtypeid">{{
                item1.comtypename
              }}</i-option>
            </i-select>
          </div>
          <div v-if="type == 2" style="margin-top: 10px">
            是否发送报警短信
            <RadioGroup v-model="types" type="button" @on-change="typechange">
              <Radio label="是" />
              <Radio label="否" />
            </RadioGroup>
            <div v-if="types == '是'">
              <Input v-model="sendtime" class="inptext" size="large" placeholder="请设置报警短信发送间隔时间">
                <span slot="append">分</span>
              </Input>
              <Input v-model="sendPhones" class="inptext" size="large" placeholder="报警手机号。多个号码用,分割" />
            </div>
          </div>
          <Input v-model="username" class="inptext" size="large" placeholder="登录用户名" />
          <Input v-model="companyname" class="inptext" size="large" placeholder="请输入企业名称" />
          <Cascader v-model="areaid" :data="areadata" placeholder="请选择省市区" class="inptext" change-on-select />
          <Input v-model="jtdz" class="inptext" size="large" placeholder="请输入具体地址" />
          <Input v-model="fr" class="inptext" size="large" placeholder="请输入企业法人" />
          <Input v-model="phone" class="inptext" size="large" placeholder="请输入企业联系方(手机号码)" />
          <Input v-model="hy" class="inptext" size="large" placeholder="请输入企业所属行业" />
          <div>
            <Input v-model="xy" class="inptext" size="large" placeholder="经度-纬度选择" />
            <Button type="primary" style="margin-top: 0.625rem; margin-left: 1.25rem" @click="getxy">拾取坐标</Button>
          </div>

          <Input
            v-model="Info"
            class="inpuarea"
            :autosize="{ minRows: 3, maxRows: 7 }"
            type="textarea"
            placeholder="请输入简介信息"
          />
        </div>
        <div class="btnbox">
          <Button @click="backmast">取消</Button>
          <Button type="info" @click="addcompany">提交</Button>
        </div>
      </Card>
    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fruit: [],
      username: '',
      companyname: '',
      jtdz: '',
      fr: '',
      jiedao: '',
      jiedaoId: '',
      jiedaoList: [],
      phone: '',
      selectbtn: false,
      hy: '',
      types: '否',
      street_id: '',
      xy: '',
      Info: '',
      areaid: ['811', '824', '829'],
      areadata: [], // 省市县
      type: '',
      sendtime: '', //报警短信间隔时间
      sendPhones: '', //报警手机号码 多个
      comtype: [
        {
          comtypeid: 0,
          comtypename: '工况公司',
        },
        {
          comtypeid: 1,
          comtypename: '油烟公司',
        },
        {
          comtypeid: 2,
          comtypename: '在线公司',
        },
        {
          comtypeid: 3,
          comtypename: '扬尘公司',
        },
      ],
    };
  },

  mounted() {
    this.getsheng();
    this.getjiedao();
  },
  methods: {
    //是否接收信息事件
    typechange() {
      if (this.types == '否') {
        this.sendtime = '';
        this.sendPhones = '';
      }
    },
    // 刷新页面
    reload() {
      location.reload();
    },
    getsheng() {
      const that = this;
      const api = this.ApiUrl + 'area/findAllArea';
      const data = {
        area_id: 1,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            const list = res.data.extend.area;
            that.areadata = list;
            for (var i = 0; i < that.areadata.length; i++) {
              if (!that.areadata[i].children) {
                that.areadata[i].children = that.areadata[i].list2;
              }
            }
          }
        },
        res => {},
      );
    },
    selectbtns(e) {
      this.selectbtn = e;
    },
    getjiedao() {
      const that = this;
      const api = this.ApiUrl + 'street/findAll';
      const data = {};
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            const list = res.data.extend.pageInfo;
            that.jiedaoList = list;
          }
        },
        res => {},
      );
    },
    addcompany() {
      const that = this;
      if (that.username === '' || that.username == null) {
        this.$Message.warning('请输入用户名');
        return;
      }
      if (that.companyname === '' || that.companyname == null) {
        this.$Message.warning('请输入公司名');
        return;
      }
      if (that.xy === '' || that.xy == null) {
        this.$Message.warning('请输入经纬度');
        return;
      }

      if (that.areaid === '' || that.areaid == null) {
        this.$Message.warning('请选择地址');
        return;
      }
      if (that.areaid.length < 3) {
        this.$Message.warning('请选择地址');
        return;
      }
      if (that.jtdz === '' || that.jtdz == null) {
        this.$Message.warning('请填写具体地址');
        return;
      }
      let tyStatus;
      if (this.type == 2) {
        tyStatus = that.types == '是' ? 0 : 1;

        if (that.types == '是') {
          if (!this.sendtime) {
            this.$Message.error('请输入报警短信发送间隔时间');
            return;
          }
          if (!this.sendPhones) {
            this.$Message.error('请输入报警号码');
            return;
          }

          if (this.phone) {
            if (this.phone.length != 11) {
              this.$Message.error('输入的手机号码长度有误');
            }
          } else {
            this.$Message.error('请输入手机号码');
          }
        }
      } else {
        tyStatus = 1;
      }
      let show = '';
      for (var i = 0; i < that.fruit.length; i++) {
        if (i < that.fruit.length - 1) {
          show += that.fruit[i] + '|';
        } else {
          show += that.fruit[i];
        }
      }
      this.street_id = this.jiedaoId;
      const data = {
        send_status: tyStatus,
        account: that.username,
        company_name: that.companyname,
        area_id: that.areaid[2],
        address: that.jtdz,
        phone: that.phone,
        legalPerson: that.fr,
        industry: that.hy,
        xy: that.xy,
        information: that.Info,
        show: show,
        street_id: this.street_id,
        type: this.type,
        send_interval: this.sendtime,
        sms_phone: this.sendPhones,
      };
      const api = this.ApiUrl + 'company/addCompany';

      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('添加成功');
            setTimeout(function () {
              that.$router.push({ path: '/system/adminlist' });
            }, 2000);
          } else {
            this.$Message.error('成功失败:' + res.data.extend.message);
          }
        },
        res => {},
      );
    },
    /**
     * 经纬度选择网站
     */
    getxy() {
      window.open('http://api.map.baidu.com/lbsapi/getpoint/index.html');
    },
    idgaibian(e) {
      this.jiedaoId = e;
    },
    typeidgaibian(e) {
      this.type = e;
    },
    // 返回主页
    backmast() {
      this.$router.push({
        path: '/system/adminlist',
      });
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.picbox {
  height: 12.5rem;
  width: 12.5rem;
  border: 1px solid #ccc;
}
.titlable {
  height: 24px;
  border-left: 0.125rem solid #17233d;
  padding-left: 20px;
  line-height: 24px;
  margin-bottom: 20px;
}

.cominfo {
  display: flex;
  flex-direction: column;
}
.ivu-input {
  width: 25rem;
}
.inptext {
  margin-top: 0.625rem;
  width: 25rem;
}

.inpuarea {
  margin-top: 0.625rem;
  width: 25rem;
}

.btnbox {
  margin-top: 1.25rem;
  width: 25rem;
  display: flex;
}
.btnbox > button {
  margin-right: 200px;
}
</style>
